module.exports = __webpack_public_path__ + "img/tractor.be1b3774.jpeg";